export const BOOKING_STATUSES = [
  'Available',
  'Reserved',
  'Booking Confirmed',
  'Checked Out',
  'Unavailable',
];

export function getCategoryName(category) {
  return category?.categoryName || category?.name || '';
}

export function getCategoryImage(category) {
  return category?.imageUrl || category?.imageURL || category?.image_url || '';
}

export function getUploadUrl(response) {
  return response?.data?.url || response?.data?.message || response?.data?.data?.url || '';
}

export function emptyProductForm() {
  return {
    categoryId: '',
    description: '',
    name: '',
    imageURL: '',
    price: '',
    bookingStatus: 'Available',
    features: ['', '', ''],
    carousel_imgs: ['', '', '', ''],
  };
}

export function productToForm(product) {
  const values = emptyProductForm();
  return {
    ...values,
    categoryId: product?.categoryId || '',
    description: product?.description || '',
    name: product?.name || '',
    imageURL: product?.imageURL || '',
    price: product?.price || '',
    bookingStatus: product?.bookingStatus || 'Available',
    features: product?.features?.length ? product.features : values.features,
    carousel_imgs: product?.carousel_imgs?.length ? product.carousel_imgs : values.carousel_imgs,
  };
}

export function productPayload(formData) {
  return {
    categoryId: Number(formData.categoryId),
    description: formData.description,
    name: formData.name,
    imageURL: formData.imageURL,
    price: Number(formData.price),
    bookingStatus: formData.bookingStatus,
    features: formData.features.map((item) => item.trim()).filter(Boolean),
    carousel_imgs: formData.carousel_imgs.map((item) => item.trim()).filter(Boolean),
  };
}

export function categoryPayload(formData) {
  return {
    categoryName: formData.categoryName,
    description: formData.description,
    imageUrl: formData.imageUrl,
  };
}
